import { useMutation } from "react-query";
import setOnboardingModalDismissed from "../services/setOnboardingModalDismissed";

function useSetOnboardingModalDismissed() {
  return useMutation(
    ["set-onboarding-modal-dismissed"],
    setOnboardingModalDismissed
  );
}

export default useSetOnboardingModalDismissed;
